// Tiny race-safe buffer for inbound `webrtc:offer` events. Background
// problem: when the agent accepts an invite, we emit the accept response
// and then navigate to /conversation/:id. The visitor side fires its
// `webrtc:offer` the instant it sees `accept`, which can land BEFORE the
// Conversation route has mounted `watchForOffer`. Without a buffer that
// offer is dropped and the call hangs at "Connecting…".
//
// The agent-app's bus-bridge stashes the most recent offer per session
// here; `watchForOffer` drains it on mount.

import type { RTCSessionDescriptionLike, SessionId } from '@prakash-software/shared';

const pendingOffers = new Map<SessionId, RTCSessionDescriptionLike>();

export function bufferOffer(sessionId: SessionId, sdp: RTCSessionDescriptionLike): void {
  pendingOffers.set(sessionId, sdp);
}

export function takeBufferedOffer(
  sessionId: SessionId,
): RTCSessionDescriptionLike | null {
  const sdp = pendingOffers.get(sessionId);
  if (!sdp) return null;
  pendingOffers.delete(sessionId);
  return sdp;
}

export function clearBufferedOffer(sessionId: SessionId): void {
  pendingOffers.delete(sessionId);
}
